export default {
    id: null,
    urban_village : "",
    sub_district : "",
    district : "",
    province : "",
    area_id : "",
    area_desc : "",
    postal_code : ""
}